import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AddCall } from 'src/providers/addvCall';
@Component({
  selector: 'app-bookingdatemodal',
  templateUrl: './bookingdatemodal.page.html',
  styleUrls: ['./bookingdatemodal.page.scss'],
})
export class BookingdatemodalPage implements OnInit {
  @Input() msg: any;
  @Input() sts: any;
  @Input() BookedMemberD: any[];
  showloading: boolean = true;
  fillbut: boolean;
  acceptbut: boolean;

  constructor(public modalCtrl: ModalController, public addCall: AddCall) {}

  ngOnInit() {
    this.fillbut = true;
    this.acceptbut = true;
  }

  ionViewWillEnter() {
    // Ensure BookedMemberD is properly initialized

    setTimeout(() => {
      this.callDelayedFunction();
    }, 15000); // 10000 milliseconds = 10 seconds
  }

  callDelayedFunction() {
    // Your function logic here
    console.log('Function called after 10-second delay',this.BookedMemberD);
    this.showloading = false;
    // Add your specific function logic here
  }

  okay(yes: boolean) {
    this.acceptbut = false;
    if (this.sts === 3) {
      this.modalCtrl.dismiss('nursebookinghistory');
    } else {
      this.modalCtrl.dismiss(yes);
    }
  }

  no(no: boolean) {
    this.fillbut = false;
    this.modalCtrl.dismiss(no);
  }

  NO(data: any) {
    this.modalCtrl.dismiss(data);
  }

  Yes(data: any) {
    this.modalCtrl.dismiss(data);
  }
}
